<template>
  <div class="mt-3">
    <div v-for="(item, index) in items" :key="index" class="" >      
      <div class="timeline-item">
        <div class="timeline-item-content">
          <span class="line" v-if="item?.line"></span>
          <span class="dot"></span>

          <div :class="`timeline-item-content-pill ${item?.line ? 'primary' : ''}`">
            <span class="data">{{ getDataFinalizacao(index, items) ? items[index].data_cadastro : item.data_cadastro }}</span> |
            <span class="conteudo">{{ item.content }}</span> |
            <span class="usuario">{{ item.usuario_tarefa }}</span>
          </div>
        </div>

        <!-- <div style="background-color: aqua; display: block; flex-direction: row; flex-basis:content;">Teste</div> -->
        <div v-if="item.data_finalizacao" class="btn-action">  

          <v-tooltip color="#666" top>
            <template v-slot:activator="{ on, attrs }">
              <span :class="`
                date-button ${ item?.stopped !== null ? 'date-button-stopped' : 'date-button-default'}
              `" v-bind="attrs"
                v-on="on">
                <SGPIconComponent 
                  color="primary" 
                  v-if="item?.stopped !== null"
                >
                    mdi-pause-circle-outline
                </SGPIconComponent>
                <strong v-else>FIM</strong>
                <strong>{{ item.data_finalizacao }}</strong>
              </span>
            </template>
            <span>
              <strong>Aging: {{ item.aging_dias }}</strong>
            </span>
          </v-tooltip>
        </div>
        <div v-else class="btn-action">
          <SGPFormBotaoComponent
              color="orange"
              x-small
              fab
              @click="irParaTarefa(item.pco_tarefa_id)"
              :disabled="item.pco_tarefa_id == item.pco_tarefa_atual"
            >
            <v-icon
              color="#000"
            >mdi-launch</v-icon>
          </SGPFormBotaoComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SGPFlowTimelineComponent",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return  {
      url_ficha_tecnica: process.env.VUE_APP_FICHA_TECNICA_URL
    }
  },

  methods: {
    getDataFinalizacao (i, items) {
      return i < (items.length - 1)
    },

    irParaTarefa (pcoTarefaId) {
      this.$router.push({
        name: 'ficha-tecnica-tarefa',
        params: { pco_tarefa_id: String(pcoTarefaId) }
      });
    }
  }
}
</script>

<style lang="scss">
$primary: #e3262e;

.line-vert {
      display: block;
      margin-left: 100px;
      height: 18px;
      width: 3px;
      background: $primary;
    }

.timeline-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  &::before {
    content: "";
    width: 85%;
    position: absolute;
    background-color: #ccc;
    height: 0px;
    margin-left: 120px;
    z-index: inherit;
    border-bottom: dotted 1px #f4f4f4;
  }

  .btn-action {
    z-index: 10;
  }

  .date-button {
    background: #F8F8F8;
    padding: 8px 12px;    
    border-radius: 8px;
    display: flex;
    width: 196px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
  }

  .date-button-default {
    border: solid 1px #444;
    z-index: 10;
  }
  .date-button-stopped { 
    border: solid 1px $primary;
    color: $primary;
    z-index: 10;
  }

  .timeline-item-content {
    display: flex;
    align-items: center;
    min-height: 36px;
    margin: 10px 0;
    z-index: 10;

    .timeline-item-content-pill {
      padding: 8px 12px;
      background-color: #888888;
      border-radius: 8px;
      color: #fff;

      .data { margin-right: 10px; color: #fff; }
      .conteudo{ margin: 0 10px; color: yellow; }
      .usuario { margin-left: 10px; color:#fff; }
    }

    span.dot {
      width: 20px;
      height: 20px;
      display: inline-block;
      background: $primary;
      border-radius: 10px;
      margin-right: 10px;
    }

    span.line {
      width: 40px;
      margin-top: calc(30px / 2);
      margin-left: 8px;
      height: 20px;
      display: flex;
      border-left: solid 3px $primary;
      border-top: solid 3px $primary;
      border-radius: 8px 0 0 0;
      margin-right: 10px;
    }
  }
}
</style>